/** 获取当前路由Path */
// eslint-disable-next-line import/prefer-default-export
export function getCurrentRoutePath() {
  const currentRouteHash = window.location.hash.replace('#', '') || '/';
  return currentRouteHash.split('?')[0] || '/';
}
